import dayjs from "dayjs";

import { Utils } from "utils";
import { IRouteDay } from "types";
import {
  WEEKDAYS,
  START_OF_THE_DAY_BREAKTIME_IN_MINUTES,
} from "constants/constants";

export class DateAvailability {
  constructor(private routeDays: IRouteDay[]) {
    this.routeDays = routeDays;
  }

  public hasNotAvailable() {
    let hasNotAvailablePlace = false;

    this.routeDays.forEach((day, index) => {
      const selectedPlaces = day.selectedPlaces;

      selectedPlaces.forEach((place) => {
        const currentDate = dayjs().add(index, "days");
        if (place) {
          const isAvailable = Utils.Places.availableForDate(currentDate, place);
          if (isAvailable === false) {
            console.log({ date: currentDate.format("DD"), place });
            hasNotAvailablePlace = true;
          }
        }
      });
    });

    return hasNotAvailablePlace;
  }

  public fixAvailability() {
    const updated = this.routeDays.map((day, dayIndex) => {
      let waypoints = day.selectedWaypoints;
      let selectedPlaces = day.selectedPlaces;
      let suggestedPlaces = day.suggestedPlaces;

      console.log("fixAvailabilit()", { waypoints, selectedPlaces });

      const removeStartDayPlace = (_: any, index: number) => index !== 0;

      if (
        selectedPlaces.at(0)?.breaktime ===
        START_OF_THE_DAY_BREAKTIME_IN_MINUTES
      ) {
        waypoints = waypoints.filter(removeStartDayPlace);
        selectedPlaces = selectedPlaces.filter(removeStartDayPlace);
        suggestedPlaces = suggestedPlaces.filter(removeStartDayPlace);
      }

      let updatedWaypoints: typeof waypoints = [];
      let removedPlaces: typeof selectedPlaces = [];
      let updatedSelectedPlaces: typeof selectedPlaces = [];
      let updatedSuggestedPlaces: typeof suggestedPlaces = [];

      for (const [index, place] of selectedPlaces.entries()) {
        if (place) {
          const currentDate = dayjs().add(dayIndex, "days");
          let isAvailable = Utils.Places.availableForDate(currentDate, place);

          /* Do not check availability if passTimetableCheck === true  */
          if (Utils.Places.passTimetableCheck(place)) {
            isAvailable = true;
          }

          if (isAvailable === false) {
            const currentSuggested = Utils.Places.sortByCustomRating(
              suggestedPlaces[index]
            );

            console.log(
              `NOT AVAILABLE PLACE AT: Day (${
                dayIndex + 1
              }) ${currentDate.format("DD")} ${WEEKDAYS[currentDate.day()]}`
            );
            console.log(
              `PLACE: ${place.title}, REPLACED WITH: ${
                currentSuggested.at(0)?.title ?? "-/-"
              }`
            );

            removedPlaces.push(place);

            if (currentSuggested.length > 0) {
              const suggestedPlace = currentSuggested[0];

              updatedSelectedPlaces.push(suggestedPlace);
              updatedWaypoints.push({
                lat: suggestedPlace.latitude,
                lng: suggestedPlace.longitude,
              });
              updatedSuggestedPlaces.push(
                suggestedPlaces[index].filter(
                  (item) => item.id !== suggestedPlace.id
                )
              );
            }
          } else {
            updatedWaypoints.push(waypoints[index]);
            updatedSelectedPlaces.push(selectedPlaces[index]);
            updatedSuggestedPlaces.push(suggestedPlaces[index]);
          }
        } else {
          updatedWaypoints.push(waypoints[index]);
          updatedSelectedPlaces.push(selectedPlaces[index]);
          updatedSuggestedPlaces.push(suggestedPlaces[index]);
        }
      }

      return {
        removedPlaces,
        waypoints: updatedWaypoints,
        places: updatedSelectedPlaces,
        suggestedPlaces: updatedSuggestedPlaces,
      };
    });

    return {
      places: updated.map((item) => item.places).flat(1),
      waypoints: updated.map((item) => item.waypoints).flat(1),
      removedPlaces: updated.map((item) => item.removedPlaces).flat(1),
    };
  }
}
